import React, { useEffect, useRef, FC } from 'react';
import { Container } from '@goldbely/explore-component-library';
import cls from 'classnames';

import { useClickOutside } from 'src/explore/hooks/useClickOutside';
import { useEscape } from 'src/explore/hooks/useEscape';

import Close from '../../../../../../atoms/Close';
import Input from './atoms/Input';

import styles from './index.module.sass';

interface FormProps {
  isOverlay: boolean;
  onClose: () => void;
}

const Form: FC<FormProps> = ({ isOverlay, onClose }) => {
  const ref = useRef( null );
  useClickOutside( ref.current, onClose );

  useEscape( onClose );

  useEffect(() => {
    const handleScroll = () => {
      onClose();
    };
    document.addEventListener( 'scroll', handleScroll );
    return () => {
      document.removeEventListener( 'scroll', handleScroll );
    };
  }, [ onClose ]);

  return (
    <Container className={cls( styles.container, { [styles.overlay]: isOverlay })} ref={ref}>
      <div className={cls( styles.content, { [styles.overlay]: isOverlay })}>
        <Input />

        <Close className={styles.close} onClick={onClose} />
      </div>
    </Container>
  );
};

export default Form;
